/**
 * @generated SignedSource<<cf69c3d2b3217cb046967636c14f2756>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SharedRelatedItemsSection_user$data = {
  readonly serviceId: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"SharedItemTile_user">;
  readonly " $fragmentType": "SharedRelatedItemsSection_user";
};
export type SharedRelatedItemsSection_user$key = {
  readonly " $data"?: SharedRelatedItemsSection_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"SharedRelatedItemsSection_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SharedRelatedItemsSection_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedItemTile_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "35e747302b1a466fcbfc378da18d5b58";

export default node;
